<template>
  <div>
    <el-form :model="query" ref="queryForm" :inline="true">
      <el-form-item label="身份：">
        <el-select v-model="query.levelId" placeholder="请选择" clearable size="small" @change="handleTechnical">
          <el-option v-for="(item,index) in technicalServiceLevel" :key="index" :label="item.value"
            :value="item.key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态：">
        <el-select v-model="query.status" placeholder="请选择" clearable size="small">
          <el-option label="在职" :value="10"></el-option>
          <el-option label="离职" :value="30"></el-option>
          <el-option label="离职交接中" :value="20"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="加入时间：">
        <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleDownload" size="mini">导出</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import technicalServiceLevelApi from '@/api/sys/technicalServiceLevel'
import technicianInfoApi from '@/api/technical/technicianInfo'
export default {
  props: ['isIntegral'],
  data() {
    return {
      dateTime: [],
      list: [],
      total: 0,
      listLoading: true,
      query: {
        levelId: null,
        status:null
      },
      technicalServiceLevel:[],
      topicClassOptions: [],
    }
  },
  created() {
    this.getLevel()
  },
  methods: {
    getLevel(){
      technicalServiceLevelApi.findOptions().then(({
        data
      }) => {
        this.technicalServiceLevel = data
      })
    },
    handleDownload() {
      this.query.createdTimeStart = this.dateTime && this.dateTime.length > 0 ? this.dateTime[0] : undefined
      this.query.createdTimeEnd = this.dateTime && this.dateTime.length > 0 ? this.dateTime[1] : undefined
      return this.$common.confirm('是否确认导出')
        .then(() => technicianInfoApi.exportExcels(this.query)).then((res) => {
          if (res.code === '0') {
            setTimeout(() => {
              this.$emit('created')
            }, 500)

          }
        })
    },

  }

}
</script>

<style>
</style>
